import React from 'react';

const V2TestContainer = () => <div>eBat ou chrono V1</div>;

export default V2TestContainer;
